import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef, useEffect } from 'react';
export const Tooltip = ({ title, placement = 'top', children }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [adjustedPlacement, setAdjustedPlacement] = useState(placement);
    const tooltipRef = useRef(null);
    const positionClasses = {
        top: 'bottom-full left-1/2 transform -translate-x-1/2 mb-2',
        bottom: 'top-full left-1/2 transform -translate-x-1/2 mt-2',
        left: 'right-full top-1/2 transform -translate-y-1/2 mr-2',
        right: 'left-full top-1/2 transform -translate-y-1/2 ml-2',
    };
    useEffect(() => {
        if (isVisible && tooltipRef.current) {
            const tooltipRect = tooltipRef.current.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            if (placement === 'top' && tooltipRect.top < 0) {
                setAdjustedPlacement('bottom');
            }
            else if (placement === 'bottom' && tooltipRect.bottom > viewportHeight) {
                setAdjustedPlacement('top');
            }
            else if (placement === 'left' && tooltipRect.left < 0) {
                setAdjustedPlacement('right');
            }
            else if (placement === 'right' && tooltipRect.right > viewportWidth) {
                setAdjustedPlacement('left');
            }
            else {
                setAdjustedPlacement(placement);
            }
        }
    }, [isVisible, placement]);
    return (_jsxs("div", { className: 'relative flex items-center', onMouseEnter: () => setIsVisible(true), onMouseLeave: () => setIsVisible(false), children: [children, isVisible && (_jsxs("div", { ref: tooltipRef, className: `absolute z-100000 px-2 py-1 text-xs font-medium text-white bg-gray-800 rounded shadow-lg whitespace-normal ${positionClasses[adjustedPlacement]}`, style: { maxWidth: '200px' }, children: [title, _jsx("div", { className: `absolute w-2 h-2 bg-gray-800 rotate-45 ${adjustedPlacement === 'top'
                            ? 'bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1'
                            : ''} ${adjustedPlacement === 'bottom' ? 'top-0 left-1/2 transform -translate-x-1/2 -translate-y-1' : ''} ${adjustedPlacement === 'left'
                            ? 'right-0 top-1/2 transform -translate-y-1/2 translate-x-1'
                            : ''} ${adjustedPlacement === 'right'
                            ? 'left-0 top-1/2 transform -translate-y-1/2 -translate-x-1'
                            : ''}` })] }))] }));
};
